<div fxFlexLayout="column" fxLayoutAlign="space-around center" class="main-buttons-row pb-3">
  <div *ngFor="let element of menuElementsToShow" [fxFlex]="100 / menuElementsToShow.length"
    [ngClass]="{ 'active': mainElement?.route == element.route }" fxLayoutAlign="center center">
    <button mat-icon-button [disabled]="mainElement?.route == element.route" [routerLink]="['../', element.route]"
      matTooltip="{{ element.name | translate }}">
      <mat-icon [svgIcon]="element.icon"></mat-icon>
    </button>
  </div>
</div>